import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResponse } from '../../../shared/commons/page-response';
import { BanDto, Level, StandardCodeDto } from '../../../../generated-model/models';

export type BanWordLevel = Level.major | Level.minor;

@Injectable({ providedIn: 'root' })
export class BanService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/bans';

  getAllBans(page: number, size: number, level?: BanWordLevel | '', standardCode?: string, state: number | null = null): Observable<PageResponse<BanDto>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (level) {
      params = params.set('level', level);
    }
    if (standardCode && standardCode.trim()) {
      params = params.set('standardCode', standardCode.trim());
    }
    if (state != null) {
      params = params.set('state', state);
    }
    return this.http.get<PageResponse<BanDto>>(this.apiUrl, { params });
  }

  getBanById(id: number): Observable<BanDto> {
    return this.http.get<BanDto>(`${this.apiUrl}/${id}`);
  }

  createBan(dto: BanDto): Observable<BanDto> {
    return this.http.post<BanDto>(this.apiUrl, dto);
  }

  updateBan(id: number, dto: BanDto): Observable<BanDto> {
    return this.http.put<BanDto>(`${this.apiUrl}/${id}`, dto);
  }

  deleteBan(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  getActiveStandardCodes(): Observable<StandardCodeDto[]> {
    return this.http.get<StandardCodeDto[]>('/api/master/standard-codes/active');
  }
}
